<template>
  <!-- This template will render all the services -->
  <div class="container">
      
      <h2 class="page-head">Our Services</h2>
      
      <div class="search-container">
        <input 
          type="text" 
          v-model="searchQuery" 
          placeholder="Search for a service (e.g., 'cut', 'color', 'mani')" 
          class="service-search-input"
          @input="filterServices">
        <button class="search-icon-btn" @click="filterServices" aria-label="Search Services">
          <span class="search-icon">🔍</span>
        </button>
      </div>

      <div class="services-grid">
        
        <div class="service-card" v-for="service in filteredServices" :key="service.id">
          
          <div class="service-image-container">
  <img 
    v-if="service.image && service.image !== 'none' && service.image !== 'null'" 
    :src="getImageUrl(service.image)" 
    :alt="service.name" 
    class="service-image"
  >

  <div v-else class="service-placeholder-svg">
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/1999/xlink">
        <path d="M256,16C123.45,16,16,123.45,16,256S123.45,496,256,496s240-107.45,240-240S388.55,16,256,16ZM368.41,293c-23,43.76-69,63.13-112.41,63.13H256c-48,0-80,32-80,80v8a192.17,192.17,0,0,1-112.1-344.1A191.24,191.24,0,0,1,368.41,293Z" fill="#D1D5DB"/>
        <path d="M375,190.49c-10.49-14-11.66-31.56-3.15-46.72a71.86,71.86,0,0,1,28.82-27C378,110,351,108.31,326,112.49c-32.32,5.39-58.49,26.66-68.8,55.7a47.38,47.38,0,0,0,4.82,41.48c10.48,14,11.66,31.56,3.15,46.72a71.86,71.86,0,0,1-28.82,27c22.7,6.76,49.66,8.45,74.63,4.28,32.32-5.39,58.49-26.66,68.81-55.7A47.38,47.38,0,0,0,375,190.49Z" fill="#A1A1AA"/>
        <path d="M428.16,167.35a144.11,144.11,0,0,0-53-53,170,170,0,0,0-72.37-23.77c-36.56-3-63,18.78-83.3,37a111.49,111.49,0,0,1-24.81,17.06A61.64,61.64,0,0,0,165.3,168a96,96,0,0,0-1.3,16h-3.8c-28,0-50.62,20.3-52,47v11.77a34.77,34.77,0,0,0,7.39,21.8,96.35,96.35,0,0,0,23.32,23.32,192.39,192.39,0,0,1,69.09,69.09,96.35,96.35,0,0,0,23.32,23.32,34.77,34.77,0,0,0,21.8,7.39H256c80,0,144-64,144-144,0-32-16.14-53.11-39.71-65.74A127.35,127.35,0,0,1,387,143a143.51,143.51,0,0,1,41.16,24.35Z" fill="#D1D5DB"/>
    </svg>
  </div>
</div>
          
          <div class="service-content">
            <h3 class="service-name">{{ service.name }}</h3>
            <p class="service-description">{{ service.description }}</p>
            
            <div class="service-footer">
              <span class="service-price">${{ service.price }}</span>
              <button class="book-btn" @click="$emit('select-service', service)">
                Book Now
              </button>
            </div>
          </div>
        </div>

        <p v-if="filteredServices.length === 0" class="no-results">
          No services match your search query: "{{ searchQuery }}"
        </p>
        
      </div>
    </div>

</template>

<script>
// import the json file
import axios from 'axios'
const API_BASE_URL = `${process.env.VUE_APP_API_URL}/service/`

export default {
    name: 'AllServiceComponent',

    emits: ['select-service'],
    data() {
        return {
            searchQuery: '',
            //services: this.processServiceData(serviceData),
            services: [],
        }
    },
    async created(){
        this.services = await this.loadServices()
    },

    computed: {
        filteredServices() {
            // Converts query to lowercase for case-insensitive search
            const query = this.searchQuery.toLowerCase();
            
            if (!query) {
                return this.services;
            }

            return this.services.filter(service => 
                service.name.toLowerCase().includes(query) ||
                service.description.toLowerCase().includes(query)
            );
        }
    },
    methods: {
        filterServices() {
        },

        async loadServices() { // load services from the backend

            try {
                const response = await axios.get(`${API_BASE_URL}get_services`)
                return response.data
            } catch (error) {
                console.error("Error fetching data:", error);
                this.error = 'Failed to load products. Please try again later.';
                return []
            }
        },

        getImageUrl(filename) {
            console.log("The filename of the image in service is: ", filename)
            //const API_BASE = new URL(process.env.VUE_APP_API_URL).origin;
            //const placeholder = "https://placehold.co/600x400?text=No+Image+Available";

            // 2. Check if filename is null, undefined, empty string, or the string "none"
            if (!filename || filename === 'none' || filename === 'null') {
                return '';
            }
                    
                    //const path_to_file = `${API_BASE}/uploads/services/${filename}`;
                    //console.log("Actual path to file: ", path_to_file)*/
            return `https://api.kcafrobraids.com/uploads/services/${filename}`;
        },
    }
}
</script>

<style scoped>

.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
    font-family: var(--font-sans);
}

.page-head {
    font-family: var(--font-serif);
    font-size: 2.5rem;
    color: var(--color-maroon);
    margin-top: 2rem;
    text-align: center;
    margin-bottom: 2rem;
    padding-bottom: 10px;
    /* Elegant Gold Underline */
    border-bottom: 3px solid var(--color-gold); 
}

/* --- Search/Filter Section --- */
.search-container {
    display: flex;
    width: 85%; 
    max-width: 600px;
    margin: 0 auto 3rem;
    border: 2px solid var(--color-maroon); /* Maroon border */
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.service-search-input {
    flex-grow: 1;
    padding: 10px 15px; 
    border: none;
    font-size: 1rem; 
    outline: none;
    color: var(--color-dark);
}

.service-search-input::placeholder {
    color: #999;
}

.search-icon-btn {
    background: var(--color-maroon); /* Maroon button */
    border: none;
    padding: 10px 18px; 
    cursor: pointer;
    transition: background-color 0.3s;
}

.search-icon-btn:hover {
    background-color: var(--color-earth); /* Earth tone on hover */
}

.search-icon {
    font-size: 1rem;
    color: white;
}

/* --- Service Cards Grid --- */
.services-grid {
    display: grid;
    grid-template-columns: 1fr; 
    gap: 30px; /* Increased gap for better separation */
    padding-bottom: 3rem;
}

/* Tablet Layout (2 columns) */
@media (min-width: 650px) {
    .services-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

/* Desktop Layout (3 columns) */
@media (min-width: 1000px) {
    .services-grid {
        grid-template-columns: repeat(3, 1fr);
    }
}

/* Individual Service Card*/
.service-card {
    border: 1px solid #f0f0f0;
    border-radius: 12px;
    overflow: hidden;
    /* More pronounced shadow for elegance */
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1); 
    display: flex;
    flex-direction: column;
    background-color: white;
    transition: box-shadow 0.3s, transform 0.2s;
}

.service-card:hover {
    box-shadow: 0 12px 25px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
}

.service-image-container {
    width: 100%; /* Changed to 100% to fill card width */
    padding-top: 60%; 
    position: relative;
    overflow: hidden;
    /* Add a subtle Gold separator below the image */
    border-bottom: 3px solid var(--color-gold); 
}

.service-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s;
}

.service-card:hover .service-image {
    transform: scale(1.05);
}

.service-content {
    padding: 20px 25px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
}

.service-name {
    font-family: var(--font-serif);
    font-size: 1.5rem;
    color: var(--color-dark);
    margin-top: 0;
    margin-bottom: 8px;
}

.service-description{
    font-size: 0.95rem;
    color: #666;
    margin-bottom: 15px;
    flex-grow: 1;
}

/* Footer (Price and Button) */
.service-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 15px;
    border-top: 1px solid #f0f0f0;
}

.service-price {
    font-size: 1.4rem;
    font-weight: bold;
    color: var(--color-earth); /* Price highlighted with Earth tone */
}

.book-btn {
    background-color: var(--color-maroon);
    color: white;
    text-decoration: none;
    padding: 10px 18px;
    border-radius: 20px; /* Pill shape for elegance */
    font-size: 0.9rem;
    font-weight: 600;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s, box-shadow 0.2s;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.book-btn:hover {
    background-color: #4a0c19; /* Darker Maroon */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.no-results {
    grid-column: 1 / -1; 
    text-align: center;
    color: var(--color-maroon);
    padding: 40px;
    font-size: 1.2rem;
    font-style: italic;
    border: 2px dashed var(--color-gold);
    border-radius: 8px;
    background-color: #fffaf0; /* Light background for message */
}

/* Placeholder styling for imageless contacts look */
/* Placeholder styling for SALON aesthetic */
.service-placeholder-svg {
    position: absolute; /* Essential for aspect ratio container */
    top: 0;
    left: 0;
    width: 100%;
    height: 100%; 
    
    display: flex;
    justify-content: center;
    align-items: center;
    
    /* contact-list color aesthetic (light-gray grayscale) */
    background-color: #F3F4F6; /* grayscale-100 */
}

.service-placeholder-svg svg {
    /* Set the initial size of the female profile silhouette */
    width: 80%; /* Filled more space than the generic contact icon */
    height: 80%;
    opacity: 0.8; /* Slightly more opaque so it doesn't look like an error */
}

/* Ensure real images still cover the container */
.service-image {
    object-fit: cover;
    width: 100%;
    height: 100%;
}

</style>